module.exports = __webpack_public_path__ + "static/news-img-ce47f13ab9e92cbf680dab9f2fc73051.jpg";